import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, normalizeClass as _normalizeClass, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"
import _imports_0 from '../../../../../assets/images/chat/reply.svg'


const _hoisted_1 = ["id"]
const _hoisted_2 = {
  key: 0,
  class: "d-flex align-items-end w-90"
}
const _hoisted_3 = { class: "message-body" }
const _hoisted_4 = {
  key: 0,
  class: "d-flex message-info justify-content-between w-100"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "me-2" }
const _hoisted_7 = { class: "me-2" }
const _hoisted_8 = {
  key: 1,
  class: "me-2"
}
const _hoisted_9 = {
  key: 1,
  class: "fw-bold text-danger pe-3"
}
const _hoisted_10 = {
  key: 1,
  class: "d-flex align-items-center others-message-body highlight-body fst-italic"
}
const _hoisted_11 = {
  key: 2,
  class: "d-flex align-items-start"
}
const _hoisted_12 = { class: "others-message-body highlight-body" }
const _hoisted_13 = { class: "d-flex w-100" }
const _hoisted_14 = { class: "message-info reply-message-info" }
const _hoisted_15 = { class: "me-2" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "me-2" }
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = { key: 1 }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user-circle fa-lg pe-1" }, null, -1 /* HOISTED */)
const _hoisted_21 = ["innerHTML"]
const _hoisted_22 = {
  key: 1,
  class: "profile-box"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user-circle fa-lg pe-1" }, null, -1 /* HOISTED */)
const _hoisted_24 = ["onClick"]
const _hoisted_25 = {
  key: 0,
  class: "loader-parent"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "msg-loader" }, null, -1 /* HOISTED */)
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = {
  key: 1,
  class: "d-flex flex-wrap gap-1"
}
const _hoisted_29 = {
  key: 0,
  class: "position-relative"
}
const _hoisted_30 = ["src", "alt", "onClick"]
const _hoisted_31 = ["onClick"]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-download me-1" }, null, -1 /* HOISTED */)
const _hoisted_33 = { class: "file-size" }
const _hoisted_34 = { key: 1 }
const _hoisted_35 = { class: "m-1 py-2 px-2 file-render text-light d-flex flex-column justify-content-end position-relative" }
const _hoisted_36 = ["onClick", "href"]
const _hoisted_37 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-download me-1" }, null, -1 /* HOISTED */)
const _hoisted_38 = { class: "file-size" }
const _hoisted_39 = { class: "fw-bold mb-0" }
const _hoisted_40 = { class: "mb-0 file-details" }
const _hoisted_41 = { class: "pe-1" }
const _hoisted_42 = { class: "file-size" }
const _hoisted_43 = { class: "hover-actions-card" }
const _hoisted_44 = { class: "hover-reactions" }
const _hoisted_45 = ["onClick"]
const _hoisted_46 = /*#__PURE__*/_createElementVNode("div", { class: "hover-divider" }, null, -1 /* HOISTED */)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1 /* HOISTED */)
const _hoisted_48 = [
  _hoisted_47
]
const _hoisted_49 = {
  key: 0,
  class: "ms-2 text-danger"
}
const _hoisted_50 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation" }, null, -1 /* HOISTED */)
const _hoisted_51 = [
  _hoisted_50
]
const _hoisted_52 = {
  key: 1,
  class: "ms-2 text-danger fw-bold"
}
const _hoisted_53 = {
  key: 1,
  class: "message-auto-generated"
}
const _hoisted_54 = { class: "message-auto-generated--text" }
const _hoisted_55 = { class: "message-auto-generated--text" }
const _hoisted_56 = {
  key: 2,
  class: "message-auto-generated"
}
const _hoisted_57 = ["src"]
const _hoisted_58 = { class: "message-auto-generated--text" }
const _hoisted_59 = { class: "message-auto-generated--text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AvaInitials = _resolveComponent("AvaInitials")!
  const _component_EmojiPicker = _resolveComponent("EmojiPicker")!
  const _component_MessageHoverActions = _resolveComponent("MessageHoverActions")!
  const _component_MessageReactions = _resolveComponent("MessageReactions")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["d-flex w-100 others-message", { grouped: _ctx.shouldHideMessageInfo }]),
    id: `msg-id-${_ctx.message.id}`
  }, [
    (!_ctx.message.isAutoGenerated)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_AvaInitials, {
            classes: "ava-sm ava-initials-main mt-1",
            initialsType: _ctx.AvaInitialsType.Single,
            user: _ctx.getUser(_ctx.getLoginIdByUserId(this.message.senderUserId)),
            showStatus: true
          }, null, 8 /* PROPS */, ["initialsType", "user"]),
          _createElementVNode("div", _hoisted_3, [
            (!_ctx.shouldHideMessageInfo || _ctx.message.isEdited || _ctx.message.isImportant)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  (!_ctx.shouldHideMessageInfo || _ctx.message.isEdited)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                        (!_ctx.shouldHideMessageInfo)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.message.senderDetails?.firstName) + " " + _toDisplayString(_ctx.message.senderDetails?.lastName || ""), 1 /* TEXT */),
                              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.formatMessageTime(_ctx.message.createdOn)), 1 /* TEXT */)
                            ], 64 /* STABLE_FRAGMENT */))
                          : _createCommentVNode("v-if", true),
                        (_ctx.message.isEdited && !_ctx.message.isDeprecated)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_8, " Edited "))
                          : _createCommentVNode("v-if", true)
                      ]))
                    : _createCommentVNode("v-if", true),
                  (_ctx.message.isImportant && !_ctx.message.isDeprecated)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, " IMPORTANT "))
                    : _createCommentVNode("v-if", true)
                ]))
              : _createCommentVNode("v-if", true),
            (_ctx.message.isDeprecated)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, " This message has been deleted. "))
              : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createVNode(_component_MessageHoverActions, {
                    "message-id": _ctx.message.id,
                    position: "right",
                    onHoverClosed: _ctx.closeEmojiPicker,
                    ref: "hoverActions"
                  }, {
                    message: _withCtx(() => [
                      _createElementVNode("div", _hoisted_12, [
                        _createCommentVNode(" Reply of Message "),
                        (_ctx.message.replyToMessage)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "card bg-form-section material-card reply-message-body my-1 cursor-pointer",
                              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleReplyMsgNavigation && _ctx.handleReplyMsgNavigation(...args)))
                            }, [
                              _createElementVNode("div", _hoisted_13, [
                                _createElementVNode("span", _hoisted_14, [
                                  _createElementVNode("span", _hoisted_15, [
                                    (_ctx.message.replyToMessage.senderDetails)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.message.replyToMessage.senderDetails.firstName) + " " + _toDisplayString(_ctx.message.replyToMessage.senderDetails?.lastName
                                                            ? _ctx.message.replyToMessage.senderDetails?.lastName
                                                            : ""), 1 /* TEXT */))
                                      : _createCommentVNode("v-if", true)
                                  ]),
                                  _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.formatMessageTime(_ctx.message.replyToMessage.createdOn)), 1 /* TEXT */)
                                ])
                              ]),
                              (_ctx.message.replyToMessage.text)
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    class: "reply-message-text my-1",
                                    innerHTML: 
                                                _ctx.sanitizeMarkup(
                                                    _ctx.markdownToHtml(_ctx.formatReplyToMsgText(_ctx.message.replyToMessage))
                                                )
                                            
                                  }, null, 8 /* PROPS */, _hoisted_18))
                                : (_ctx.replyMsgProfiles)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.replyMsgProfiles, (profile) => {
                                        return (_openBlock(), _createElementBlock("span", {
                                          key: profile.id,
                                          class: "d-inline-flex align-items-center justify-content-center share-profile me-1 mb-1 py-1 px-2"
                                        }, [
                                          _hoisted_20,
                                          _createElementVNode("span", null, _toDisplayString(profile.name), 1 /* TEXT */)
                                        ]))
                                      }), 128 /* KEYED_FRAGMENT */))
                                    ]))
                                  : _createCommentVNode("v-if", true)
                            ]))
                          : _createCommentVNode("v-if", true),
                        _createCommentVNode(" Reply of Message Ends "),
                        _createElementVNode("div", {
                          class: "message-content",
                          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleEventPropagation && _ctx.handleEventPropagation(...args))),
                          innerHTML: _ctx.sanitizeMarkup(_ctx.markdownToHtml(_ctx.formattedMessage))
                        }, null, 8 /* PROPS */, _hoisted_21),
                        (_ctx.sharedProfilesList?.length > 0)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_22, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sharedProfilesList, (profile) => {
                                return (_openBlock(), _createElementBlock("span", {
                                  key: profile.id,
                                  contenteditable: "false",
                                  class: "d-inline-flex align-items-center justify-content-center share-profile me-1 mb-1 py-1 px-2 cursor-pointer"
                                }, [
                                  _hoisted_23,
                                  _createElementVNode("span", {
                                    onClick: ($event: any) => (_ctx.redirectToProfile(profile))
                                  }, _toDisplayString(profile.name), 9 /* TEXT, PROPS */, _hoisted_24)
                                ]))
                              }), 128 /* KEYED_FRAGMENT */))
                            ]))
                          : _createCommentVNode("v-if", true),
                        (_ctx.message.assetIds.length > 0)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                              (_ctx.assetLoading)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_25, _hoisted_27))
                                : _createCommentVNode("v-if", true),
                              (_ctx.fetchedAssets.length > 0 && !_ctx.assetLoading)
                                ? (_openBlock(), _createElementBlock("ul", _hoisted_28, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fetchedAssets, (assetResponse, index) => {
                                      return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                        (_ctx.isImage(assetResponse.asset.mimeType))
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                              _createElementVNode("img", {
                                                class: _normalizeClass(`image my-2 ${
                                                            assetResponse.asset.showDownloadBtn ? 'image-blur' : ''
                                                        }`),
                                                src: assetResponse.asset.url,
                                                alt: assetResponse.asset.fileName,
                                                onClick: ($event: any) => (
                                                            assetResponse.asset.showDownloadBtn =
                                                                !assetResponse.asset.showDownloadBtn
                                                        )
                                              }, null, 10 /* CLASS, PROPS */, _hoisted_30),
                                              (assetResponse.asset.showDownloadBtn)
                                                ? (_openBlock(), _createElementBlock("a", {
                                                    key: 0,
                                                    href: "javascript:void(0);",
                                                    class: "img-download-btn",
                                                    onClick: (e) => _ctx.downloadAsset(assetResponse.asset, e)
                                                  }, [
                                                    _hoisted_32,
                                                    _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.formatFileSize(assetResponse.asset.fileSize)), 1 /* TEXT */)
                                                  ], 8 /* PROPS */, _hoisted_31))
                                                : _createCommentVNode("v-if", true)
                                            ]))
                                          : (_openBlock(), _createElementBlock("span", _hoisted_34, [
                                              _createElementVNode("div", _hoisted_35, [
                                                _createElementVNode("a", {
                                                  class: "file-download",
                                                  onClick: (e) => _ctx.downloadAsset(assetResponse.asset, e),
                                                  href: assetResponse.asset.url
                                                }, [
                                                  _hoisted_37,
                                                  _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.formatFileSize(assetResponse.asset.fileSize)), 1 /* TEXT */)
                                                ], 8 /* PROPS */, _hoisted_36),
                                                _createElementVNode("p", _hoisted_39, _toDisplayString(_ctx.truncateString(
                                                                assetResponse.asset.fileName.split(".")[0],
                                                                45
                                                            )), 1 /* TEXT */),
                                                _createElementVNode("p", _hoisted_40, [
                                                  _createElementVNode("span", _hoisted_41, _toDisplayString(assetResponse.asset.fileName.split(".").pop().toUpperCase()), 1 /* TEXT */),
                                                  _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.formatFileSize(assetResponse.asset.fileSize)), 1 /* TEXT */)
                                                ])
                                              ])
                                            ]))
                                      ], 64 /* STABLE_FRAGMENT */))
                                    }), 128 /* KEYED_FRAGMENT */))
                                  ]))
                                : _createCommentVNode("v-if", true)
                            ], 64 /* STABLE_FRAGMENT */))
                          : _createCommentVNode("v-if", true)
                      ])
                    ]),
                    actions: _withCtx(() => [
                      _createCommentVNode(" Row 1: Quick reactions + EmojiPicker "),
                      _createElementVNode("div", _hoisted_43, [
                        _createElementVNode("div", _hoisted_44, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.defaultQuickReactions, (emoji) => {
                            return (_openBlock(), _createElementBlock("span", {
                              key: emoji,
                              class: "reactions-btn",
                              onClick: ($event: any) => (_ctx.handleEmoji(emoji))
                            }, _toDisplayString(emoji), 9 /* TEXT, PROPS */, _hoisted_45))
                          }), 128 /* KEYED_FRAGMENT */)),
                          _createElementVNode("div", {
                            onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
                          }, [
                            _createVNode(_component_EmojiPicker, {
                              isHover: true,
                              ref: "emojiPicker",
                              onEmojiSelected: _ctx.handleEmoji
                            }, null, 8 /* PROPS */, ["onEmojiSelected"])
                          ]),
                          _createCommentVNode(" Divider "),
                          _hoisted_46,
                          _createCommentVNode(" Reply "),
                          _withDirectives((_openBlock(), _createElementBlock("span", {
                            class: "hover-action-btn",
                            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.replyToMessage && _ctx.replyToMessage(...args)))
                          }, _hoisted_48)), [
                            [_directive_tooltip, { title: `Reply`, placement: 'top' }]
                          ])
                        ])
                      ])
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["message-id", "onHoverClosed"]),
                  (_ctx.message.isImportant)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_49, _hoisted_51))
                    : _createCommentVNode("v-if", true),
                  _createCommentVNode(" </div> "),
                  (_ctx.showTaggedSign)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_52, "@"))
                    : _createCommentVNode("v-if", true)
                ])),
            _createVNode(_component_MessageReactions, { message: _ctx.message }, null, 8 /* PROPS */, ["message"])
          ])
        ]))
      : (
                _ctx.message.isAutoGenerated &&
                [
                    _ctx.AutoGeneratedMessageEnum.ParticipantAdded,
                    _ctx.AutoGeneratedMessageEnum.ParticipantLeft,
                    _ctx.AutoGeneratedMessageEnum.GroupNameChange
                ].includes(_ctx.message.autoMessageType)
            )
        ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
            _createElementVNode("span", _hoisted_54, _toDisplayString(_ctx.formatLocalDateWithMeridiem(_ctx.message.createdOn)), 1 /* TEXT */),
            _createElementVNode("span", _hoisted_55, _toDisplayString(_ctx.formattedMessage), 1 /* TEXT */)
          ]))
        : (_ctx.message.isAutoGenerated)
          ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
              _createElementVNode("img", {
                src: _ctx.renderImage(_ctx.message),
                class: "ms-4 ps-2"
              }, null, 8 /* PROPS */, _hoisted_57),
              _createElementVNode("span", _hoisted_58, _toDisplayString(_ctx.formatLocalDateWithMeridiem(_ctx.message.createdOn)), 1 /* TEXT */),
              _createElementVNode("span", _hoisted_59, _toDisplayString(_ctx.formattedMessage), 1 /* TEXT */)
            ]))
          : _createCommentVNode("v-if", true)
  ], 10 /* CLASS, PROPS */, _hoisted_1))
}